import { computed } from '@vue/composition-api';
import { date } from '@/util/formatters';
import { DummyFilter } from '@/components/Table/dummy-filter';
export const useSurveyColumns = (ctx, options) => {
    const columns = computed(() => {
        return [
            {
                field: 'internalNumber',
                headerName: ctx.root.$t('table-header.internal-number').toString(),
                width: 128,
                minWidth: 128,
                flex: 0,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
                suppressHeaderFilterButton: true,
            },
            {
                field: 'title',
                headerName: ctx.root.$t('brand-surveys.table.title').toString(),
                minWidth: 415,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
                suppressHeaderFilterButton: true,
            },
            {
                field: 'createdAt',
                headerName: ctx.root
                    .$t('table-header.date-of-first-publication')
                    .toString(),
                minWidth: 232,
                width: 220,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingDatepickerFiler',
                suppressFloatingFilterButton: true,
                suppressHeaderFilterButton: true,
                cellRenderer: (params) => date(params?.data?.createdAt),
            },
            {
                headerName: ctx.root
                    .$t('brand-surveys.table.questions-count')
                    .toString(),
                sortable: false,
                minWidth: 180,
                width: 180,
                cellStyle: { textAlign: 'center' },
                valueGetter: (params) => params.data?.questions?.length || 0,
            },
            {
                headerName: '',
                width: 50,
                flex: 1,
                hide: !options.canPreview,
                minWidth: 50,
                sortable: false,
                filter: false,
                cellRenderer: 'SurveyPreviewCell',
                cellRendererParams: (params) => {
                    return {
                        onPreview: options.onPreview,
                    };
                },
            },
        ];
    });
    return { columns };
};
